import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Icon } from '@reservamos/elements';

/**
 * ViajaAhorrandoPassengerLimitMessage component.
 * Renders a message indicating that passengers cannot be added because this is a Viaja Ahorrando purchase
 * (discount from Viva Aerobus original purchase).
 * @returns {JSX.Element} The rendered component.
 */
const ViajaAhorrandoPassengerLimitMessage = () => {
  const { t } = useTranslation('passengers');

  return (
    <div className="border-[1px] border-primary-regular rounded-[10px] p-4 bg-gray-50">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center self-stretch">
          <Icon type="Info" size="M" color="primary" />
        </div>
        <div className="flex-1">
          <Text size="M" weight="semibold" color="grayDark">
            {t('viaja_ahorrando.passenger_limit_title')}
          </Text>
          <Text size="S" color="grayMedium" className="mt-1">
            {t('viaja_ahorrando.passenger_limit_description')}
          </Text>
        </div>
      </div>
    </div>
  );
};

ViajaAhorrandoPassengerLimitMessage.propTypes = {};

export default ViajaAhorrandoPassengerLimitMessage;
